module.exports = __webpack_public_path__ + "static/media/ca-bobina4.f4824a03.jpg";